import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIntl } from "react-intl";
import AnchorNavigation from "../anchor_navigation/AnchorNavigation";
import { StyledContent } from "./styled";
import { RoutesList, buildPath } from "@/routes/routesList";
import { Outlet } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
var AppContent = function () {
    var intl = useIntl();
    var language = useLanguage().language;
    var links = [
        {
            label: intl.formatMessage({ id: 'link.welcome' }),
            path: buildPath(language, RoutesList.Main)
        },
        {
            label: intl.formatMessage({ id: 'link.whySahlTaxVsAgencies' }),
            path: buildPath(language, RoutesList.WhySahlTaxVsAgencies)
        },
        {
            label: intl.formatMessage({ id: 'link.whySahlTax' }),
            path: buildPath(language, RoutesList.WhySahlTax)
        },
        {
            label: intl.formatMessage({ id: 'link.pricingPlans' }),
            path: buildPath(language, RoutesList.PricingPlans)
        },
        {
            label: intl.formatMessage({ id: 'link.integrations' }),
            path: buildPath(language, RoutesList.Integrations)
        },
        {
            label: intl.formatMessage({ id: 'link.termsOfService' }),
            path: buildPath(language, RoutesList.TermsOfService)
        },
        {
            label: intl.formatMessage({ id: 'link.cookiesPolicy' }),
            path: buildPath(language, RoutesList.CookiesPolicy)
        },
        {
            label: intl.formatMessage({ id: 'link.privacyAndSecurity' }),
            path: buildPath(language, RoutesList.PrivacyAndSecurity)
        },
        {
            label: intl.formatMessage({ id: 'link.cancellationPolicy' }),
            path: buildPath(language, RoutesList.CancellationPolicy)
        },
        {
            label: intl.formatMessage({ id: 'link.faq' }),
            path: buildPath(language, RoutesList.FAQ)
        }
    ];
    return _jsxs(StyledContent, { children: [_jsx(AnchorNavigation, { links: links }), _jsx(Outlet, {})] });
};
export default AppContent;
